import { schema } from "normalizr";

export const role = new schema.Entity("role");
export const roleList = [role];
